'use strict';

var currentFilters = {
    title: '',
    refinements: {}
};

/**
 * Check if refinements match
 * @param {string} jobData - The job data
 * @param {string} refinement - The refinement to check
 * @returns {boolean} - Whether the refinements match
 */
function checkRefinementsMatch(jobData, refinement) {
    var refinementValues = currentFilters.refinements[refinement];
    if (!refinementValues || refinementValues.length === 0) {
        return true;
    }
    return refinementValues.some(function (value) {
        return jobData.toUpperCase().indexOf(value) > -1;
    });
}

/**
 * Filter jobs
 * @returns {void}
 */
function filterJobs() {
    var jobs = document.querySelectorAll('.job-list-item');

    for (var i = 0; i < jobs.length; i++) {
        var job = jobs[i];
        var jobData = job.getAttribute('data-job').toUpperCase();

        var titleMatch = true;
        if (currentFilters && currentFilters.title) {
            titleMatch = jobData && jobData.indexOf(currentFilters.title) > -1;
        }
        var refinementsMatch = true;
        if (currentFilters && Object.keys(currentFilters.refinements).length > 0) {
            refinementsMatch = Object.keys(currentFilters.refinements).every(checkRefinementsMatch.bind(null, jobData));
        }

        if (titleMatch && refinementsMatch) {
            job.style.display = '';
        } else {
            job.style.display = 'none';
        }
    }
}

/**
 * Filter jobs by job title
 * @returns {void}
 */
function filterByJobTitle() {
    var input = document.querySelector('.job-search');
    currentFilters.title = input.value.toUpperCase();
    filterJobs();
}

/**
 * Filter jobs by refinement
 * @returns {void}
 */
function filterByRefinement() {
    var refinementContainers = document.querySelectorAll('.custom-dropdown-content');

    refinementContainers.forEach(function (container) {
        var refinement = container.getAttribute('data-refinement');
        var checkedValues = [];

        var checkboxes = container.querySelectorAll('input[type="checkbox"]:checked');
        checkboxes.forEach(function (checkbox) {
            checkedValues.push(checkbox.value.trim().toUpperCase());
        });

        currentFilters.refinements[refinement] = checkedValues;
    });

    filterJobs();
}

module.exports = {
    init: function () {
        $('.job-search').on('keyup', filterByJobTitle);

        $('.custom-dropdown-content input[type="checkbox"]').on('change', filterByRefinement);

        $('.custom-dropdown-button').on('click', function (event) {
            $('.custom-dropdown').removeClass('open');

            var $dropdown = $(event.currentTarget).parent();
            $dropdown.toggleClass('open');
        });

        $(document).on('click', function (event) {
            if (!$(event.target).closest('.custom-dropdown').length) {
                $('.custom-dropdown').removeClass('open');
            }
        });
    },
    filterByJobTitle: filterByJobTitle,
    filterByRefinement: filterByRefinement
};
